import { ProducerSource } from '@amfament/digitalsales-lib-common-base/coreService';

export const typesOfAgents = [ProducerSource.VANITY];
